var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('img',{staticClass:"photo q-mb-md",attrs:{"src":_vm.photoUrl}}),_c('div',{style:(_vm.labelStyle)},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('div',{style:(_vm.sublabelStyle)},[_vm._v("\n    "+_vm._s(_vm.sublabel)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }